import React, { memo, useState } from "react";
import { useSelector } from "react-redux";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { FiBell, FiMoon, FiSun, FiLogOut, FiGlobe } from "react-icons/fi";
import { financialFloat } from "../functions.js/functions";
import { useDispatch } from "react-redux";
import { setChangeTheme } from "../redux/slices/uiSlice";
import { useTranslation } from "../i18n";

function Header({ onToggle, onLogout }) {
  const user = useSelector((state) => state.auth.user);
  const theme = useSelector((state) => state.ui.theme);
  const countNoty = useSelector((state) => state.ui.countNoty);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, lang, setLang, languages } = useTranslation();
  const [langOpen, setLangOpen] = useState(false);

  const isDark = theme === "dark-theme" || theme === "dark";
  const toggleTheme = () =>
    dispatch(setChangeTheme(isDark ? "" : "dark-theme"));

  const levelImage = user?.level_image || null;
  const levelFrameColor = user?.level_frame_color || "#9ca3af";

  return (
    <header className="header">
      <button className="header__toggle" id="toggle" aria-label={t("header.menu")} onClick={onToggle}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M3 12h18M3 6h18M3 18h18"/></svg>
      </button>

      <div className="header__actions">
        <div className="lang-switch">
          <button
            className="icon-btn"
            id="lang"
            title={t("header.changeLanguage")}
            aria-label={t("header.changeLanguage")}
            onClick={() => setLangOpen((o) => !o)}
          >
            <FiGlobe size={20} />
          </button>
          {langOpen && (
            <div className="lang-menu">
              {languages.map((l) => (
                <button
                  key={l.code}
                  className={"lang-menu__item" + (l.code === lang ? " is-active" : "")}
                  onClick={() => {
                    setLang(l.code);
                    setLangOpen(false);
                  }}
                >
                  <span className="lang-menu__flag">{l.flag}</span>
                  {l.label}
                </button>
              ))}
            </div>
          )}
        </div>
        <NavLink className="icon-btn" to="/noty" title={t("header.notifications")}>
          <FiBell size={20} />
          {countNoty > 0 && <span className="dot" />}
        </NavLink>
        <button
          className="icon-btn"
          id="theme"
          title={isDark ? t("header.lightMode") : t("header.darkMode")}
          onClick={toggleTheme}
        >
          {isDark ? <FiSun size={20} /> : <FiMoon size={20} />}
        </button>
        <div
          onClick={() => navigate("/Profile")}
          style={{
            cursor: "pointer",
            position: "relative",
            width: 40,
            height: 40,
            borderRadius: "50%",
            padding: 2,
            background: levelImage
              ? `url(${levelImage}) center/cover no-repeat`
              : levelFrameColor,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            className="avatar-btn"
            src={user?.avatar ? `${process.env.REACT_APP_UPLOADS_URL || "http://localhost:8089"}/uploads/users/` + user.avatar : "https://i.pravatar.cc/80?img=12"}
            alt="avatar"
            style={{ width: 36, height: 36, borderRadius: "50%", objectFit: "cover", display: "block" }}
          />
        </div>
      </div>
    </header>
  );
}

export default memo(Header);
